const STORAGE_KEY = 'tigerflow.service-item-favorites'

function canUseStorage() {
  return (
    typeof window !== 'undefined' && typeof window.localStorage !== 'undefined'
  )
}

export function getFavoriteServiceItemIds() {
  if (!canUseStorage()) return []

  try {
    const raw = window.localStorage.getItem(STORAGE_KEY)
    if (!raw) return []

    const parsed = JSON.parse(raw)
    if (!Array.isArray(parsed)) return []

    return parsed.filter((value): value is string => typeof value === 'string')
  } catch {
    return []
  }
}

export function setFavoriteServiceItemIds(ids: string[]) {
  if (!canUseStorage()) return

  const deduped = Array.from(new Set(ids))
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(deduped))
}

export function toggleFavoriteServiceItemId(id: string) {
  const current = getFavoriteServiceItemIds()

  if (current.includes(id)) {
    const next = current.filter(currentId => currentId !== id)
    setFavoriteServiceItemIds(next)
    return next
  }

  const next = [...current, id]
  setFavoriteServiceItemIds(next)
  return next
}
